import { HistoryActionTypes } from "./actionTypes";

export const HistoryActionCreators = {
    getActivityLogs: ({ page = 0, top = 10, event, users, range, entity_type, entity_id }) => ({
        type: HistoryActionTypes.GET_ACTIVITY,
        payload: {
            page,
            top,
            event,
            users,
            range,
            entity_type,
            entity_id
        }
    }),

    getHistoryUsers: search => ({
        type: HistoryActionTypes.GET_HISTORY_USERS,
        payload: {
            search
        }
    })
};
